import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Layout as FacetPlanNextUpNonAUMLayout } from './NextUpNonAUMSection';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',
    height: '100%',
    overflow: 'auto',
  },
}));

const FacetPlanProposalNextUpAccountDetailItemLayout = ({
  collection,
}) => {
  const classes = useStyles();

  const resource = collection.resources().head();

  return (
    <div className={classes.root}>
      <FacetPlanNextUpNonAUMLayout collection={resource.attr('itemsSection')} />
    </div>
  );
};

FacetPlanProposalNextUpAccountDetailItemLayout.propTypes = {
  collection: PropTypes.object.isRequired,
};

FacetPlanProposalNextUpAccountDetailItemLayout.defaultProps = {
};

export default FacetPlanProposalNextUpAccountDetailItemLayout;
